// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"79":"1f9eefdd","127":"eb758496"}[chunkId] + ".js";
};